// @flow
import React from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router";

const BackButton = ({onClick, absolutePosition, showBackText=false}) => {
    
    const history = useHistory();
    
    function handleGoBack() {
        if(onClick) {
            onClick();
        }
        else {
            history.goBack();
        }
    }
    
    return (
        <div id="backBtn" className={"btn "+(absolutePosition?"position-absolute":null)} onClick={handleGoBack}>
            <i className="fa fa-3x fa-arrow-circle-left"/>{showBackText && <div>back</div>}
        </div>
    );
}

BackButton.propTypes = {
    onClick: PropTypes.func,
    absolutePosition: PropTypes.bool,
    showBackText: PropTypes.bool
}

export default BackButton;